import React from 'react'
import s from './BasicWrapper.module.scss'

type BasicWrapperStyle = {
  root?: React.CSSProperties
  container?: React.CSSProperties
}

export function BasicWrapper({
  children,
  style = {},
}: Readonly<{
  children: React.ReactNode
  style?: BasicWrapperStyle
}>) {
  return (
    <section className={s.root} style={style.root}>
      <div className={s.container} style={style.container}>
        {children}
      </div>
    </section>
  )
}
